import script from "./Relatorios.vue?vue&type=script&setup=true&lang=js"
export * from "./Relatorios.vue?vue&type=script&setup=true&lang=js"

import "./Relatorios.vue?vue&type=style&index=0&id=7b482488&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b482488"]])

export default __exports__